<template>
    <div>
        <label>
            {{ title }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <date-picker 
            :value="value"
            lang="en"
            format="MM-DD-Y"
            value-type="MM-DD-Y"
            :placeholder="title" 
            :disabled-date="disabledDate"
            @input="change($event)"
            :class="{'is-invalid': error}"
        >
        </date-picker>
        <div
            v-if="error"
            class="invalid-feedback"
            style="position: absolute;"
        >
            {{ error }}
        </div>
    </div>    
</template>


<script>
    import DatePicker from "vue2-datepicker";
    export default {
        components: { DatePicker },
        props: {
            title: String,
            value: String,
            error: String,
            required: Boolean,
            disabledDate: Function
        },
        methods: {
            change(val) {
                this.$emit('input', val)
            }
        }
    }
</script>

